
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/interconnection/ip-ranges",
      function () {
        return require("private-next-pages/docs/interconnection/ip-ranges.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/interconnection/ip-ranges"])
      });
    }
  